window.addEventListener('load', () => {
    const loadCheck = window.setInterval(() => { 
        if( greenFormExists() )
        {
            window.clearTimeout(loadCheck);
            onGreenFormLoaded();
        }
    }, 500);    
})
  
const greenFormExists = () =>  {
  return $('.leform-inline').length && $('.leform-button[data-label="Create book"]').length;
};
  
const onGreenFormLoaded = () => {
    const $submitButton = $('.leform-button[data-label="Create book"]');
    const $previewButton = $('<button id="lf_btn_gf_preview">Preview book</button>');
    $previewButton.insertBefore($submitButton);

    const $buyButton = $('<button disabled id="lf_btn_gf_buy">Buy my book</button>');
    $buyButton.insertBefore($submitButton);
    
    $previewButton.on('click', function(e) { 
        handlePreview(e, $(this), $buyButton);
    });

    $submitButton.hide();
  	console.log($submitButton);
};

const handlePreview = (e, $btn, $buy) => {
    e.preventDefault();

    window.dFlipLocation = 'https://create.letterfest.com/dflip/';

    // Append the script:
    $('head')
        .append('<script src="https://create.letterfest.com/dflip/js/libs/three.min.js?ver=1.5.6" type="text/javascript"></script>')
        .append('<script src="https://create.letterfest.com/dflip/js/dflip.js" type="text/javascript"></script>');

    // Get the text to restore on the button:
    const buttonText = $btn.text();

    // Disable the button:
    $btn.prop('disabled', true).text('Making book...');

    // Get the schema ID:
    let schemaID = null;
    let id = null;

    $('input[type="hidden"]').each(function() {
        if( $(this).val().substr(0, 7) == 'schema_' )
        {
            schemaID = $(this).val().substr(7);
        }
    });

    // Now get the form element that the button exists within:
    const $form = $btn.parents('.leform-inline');

    const inputs = [ ];

    $form.find('input, textarea, select').each(function() {
        const type = $(this).prop('type');
        const label = $(this).parents('.leform-column-input').siblings('.leform-column-label').text();
        const value = $(this).val().trim();
        const name = $(this).prop('name');
        if( label.trim().toLowerCase() == 'cover type')
        {
            id = value;
        }
        else
        {
            if( (type == 'radio' || type == 'radio') )
            {
                if( $(this).is(':checked') )
                {
                    inputs.push({
                        name: name,
                        label: label,
                        value: value
                    });
                }
            }
            else
            {
                inputs.push({
                    name: name,
                    label: label,
                    value: value
                });
            }
        }
    });

    // Build the URL:
    const url = new URL('https://preview.letterfest.com/');
    url.searchParams.append('schema', schemaID);
    inputs.map((input) => { url.searchParams.append(input.name, input.value); });

    fetch(url.href)
        .then(response => response.json())
        .then(response => {

            // Add our class to the body:
            $('body').addClass('lf-preview-in');

            // Create a container for the flipboox:
            const $container = $('<div id="preview-flipbook-container"><div></div></div>');

            // There isn't a close button for the preview, so we need to create one!
            const $close = $('<button id="lf_btn_preview_close">Close preview X</button>');

            $close.add($container).appendTo('body');

            // Handle buy button:
            $buy.prop('disabled', false);

            // We need to now show the new buttons (one to essentially close, and one to add to cart):
            const $edit = $('<button id="lf_btn_preview_edit">Make changes</button>');
            const $buyButton = $('<button id="lf_btn_preview_buy">Buy my book</button>');

            $edit.add($close).on('click', function(e) { 
                e.preventDefault(); 

                $container.add($close).add($edit).add($buyButton).remove(); 
                
                $('body').removeClass('lf-preview-in');
            });

            $buy.add($buyButton).off('click').on('click', function() {
                $(this).prop('disabled', true).text('Adding to cart...');
                addToCart(inputs, id);
            });

            $edit.add($buyButton).appendTo('body');
            
            // I think this is where we'd swap out the flipbooks
            let flipbookInitialiser = setInterval(() => {
                try {
                    const flipbookInstance = $container.find('> div').flipBook(response.url, {
                        scrollWheel: false,
                        hideControls: 'altPrev,pageNumber,altNext,outline,thumbnail,zoomIn,zoomOut,fullScreen,share,more,download,pageMode,startPage,endPage,sound',
                        backgroundColor: "#eab861",
                        width: $(window).width(),
                        height: $(window).height(),
                        // width: '80%',
                        // height: '80%'
                     }); 
                     if (flipbookInstance != undefined) {
                        clearInterval(flipbookInitialiser);
                     }
                } catch (e) { }
            }, 250);
   
        })
        .finally(() => {
            $btn.prop('disabled', false).text(buttonText);
        });
};

function addToCart( params, pid )
{
    console.log(pid)
    // Build the form params:
    const formParams = { 
        id: pid,// should be pid no tick marks
        add: 'order',
        properties: { }
    };

    params.map(param => { 
        if( param.label )
        {
            formParams.properties[param.label] = param.value;
        }
    });

    $.post('/cart/add', formParams)
        .done(function() { 
            window.location.href = '/cart/';
        })
        .fail(function() { 
            alert('There was a problem adding your book to your cart. Please try again.' + JSON.stringify(formParams));
        });
}